// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RYag","index":"styles_index__1K4cK"};